import React from 'react';
import logo from './../assets/logowhite.png';
import SocialMediaIcons from './../components/SocialMediaIcons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Footer = () => {
  return (
    <footer id="contact" className="bg-teal-900">
      <div className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
        <div className="grid grid-cols-12 gap-8">
          {/* Logo and Description Section */}
          <div className="col-span-12 md:col-span-5 flex flex-col items-center md:items-start px-10">
            <div className="flex items-center">
              <img src={logo} className="h-20 mr-3" alt="Logo" />
              <span className="text-2xl font-bold text-white">Pocket LPO</span>
            </div>
            <span className="font-normal text-sm text-gray-300 mt-2 text-justify md:text-left">
              PocketLPO is dedicated to providing accessible and cost-effective legal solutions for businesses of all sizes. Our mission is to empower your business with expert legal support whenever you need it.
            </span>
            <h2 className="my-4 text-base font-bold uppercase text-white">Connect with Us</h2>
            <div className="flex text-center">
            {/* <div className="flex flex-col"> */}
                    {/* <h2 className="mb-6 text-lg font-bold uppercase text-white">Connect With Us</h2> */}
              <SocialMediaIcons/>
                {/* </div> */}
            </div>
          </div>

          {/* Services Links Section */}
          <div className="col-span-12 md:col-span-3">
            <h2 className="mb-6 text-base font-bold uppercase text-white">Services</h2>
            <ul className="text-gray-300 text-sm font-medium">
              <li className="mb-1"><a href="/services/remote-in-house-counsel" className="hover:underline">Remote In-House Counsel</a></li>
              <li className="mb-1"><a href="/services/contract-drafting-and-management" className="hover:underline">Contract Drafting & Management</a></li>
              <li className="mb-1"><a href="/services/corporate-governance-and-compliance" className="hover:underline">Corporate Governance & Compliance</a></li>
              <li className="mb-1"><a href="/services/intellectual-property-services" className="hover:underline">Intellectual Property(IP) Services</a></li>
              <li className="mb-1"><a href="/services/data-privacy-and-protection" className="hover:underline">Data Privacy & Protection Services</a></li>
              <li className="mb-1"><a href="/services/fixed-fee-legal" className="hover:underline">Fixed Fee Legal Services</a></li>
              <li className="mb-1"><a href="/services/paralegal-service" className="hover:underline">Paralegal Services</a></li>              
            </ul>
          </div>

          {/* Quick Links Section */}
          <div className="col-span-12 md:col-span-2">
            <h2 className="mb-6 text-base font-bold uppercase text-white">Quick Links</h2>
            <ul className="text-gray-300 text-sm font-medium">
              <li className="mb-1"><a href="/" className="hover:underline">Home</a></li>
              <li className="mb-1"><a href="/about" className="hover:underline">About Us</a></li>
              <li className="mb-1"><a href="/services" className="hover:underline">Services</a></li>
              <li className="mb-1"><a href="/pricing" className="hover:underline">Pricing</a></li>
              <li className="mb-1"><a href="/blogs" className="hover:underline">Blogs</a></li>
              <li className="mb-1"><a href="/faq" className="hover:underline">FAQs</a></li>
              <li className="mb-1"><a href="/contact" className="hover:underline">Contact Us</a></li>
            </ul>
          </div>

          {/* Legal Section */}
          <div className="col-span-12 md:col-span-2">
            <h2 className="mb-6 text-base font-bold uppercase text-white">Legal</h2>
            <ul className="text-gray-300 text-sm font-medium mb-6">
              <li className="mb-1"><a href="/privacypolicy" className="hover:underline">Privacy Policy</a></li>
              <li><a href="/terms" className="hover:underline">Terms &amp; Conditions</a></li>
            </ul>

            <h2 className="mb-6 text-base font-bold uppercase text-white">Get In Touch</h2>
            <ul className="text-gray-300 text-sm font-medium">
              <li className="mb-2">
                <FontAwesomeIcon icon={faEnvelope} className='text-lg mr-1'/> 
                <a href="mailto:legal@pocketlpo.com" className="hover:underline ml-2">legal@pocketlpo.com</a>
              </li>
            </ul>
          </div>
        </div>

        <hr className="my-6 sm:mx-auto border-gray-500 lg:my-8" />

        <div className="flex justify-center">
          <span className="text-sm italic text-center text-gray-300">© 2025 <a href="/" className="hover:underline">Pocket LPO™</a>. All Rights Reserved.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
